import { Icon } from "ant-design-vue";
import icons from "../assets/fonts/iconfont";
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: icons,
});

export default IconFont;
